import React from "react";
import ReactApexChart from "react-apexcharts";

const VerticalStackedBarChart = ({ siteData }) => {
  const series = siteData.map((site) => ({
    name: site.name,
    data: (site.RAP_Total_Month || Array(12).fill(0)).map(val => val || 0)
  }));

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
      height: "100%",
      width: "100%",
    },
    colors: ["#14B8A6", "#3B82F6", "#6366F1", "#EC4899", "#F59E0B", "#FACC15"],
    xaxis: {
      categories: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      labels: { style: { colors: "white" } },
    },
    yaxis: {
      labels: {
        style: { colors: "white" },
        formatter: (value) => (Number.isInteger(value) ? value : ""),
      },
    },
    legend: {
      show: true,
      position: "top",
      labels: { colors: "white" },
    },
    dataLabels: { enabled: false },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 4,
        columnWidth: "45%",
      },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          plotOptions: {
            bar: { columnWidth: "60%" },
          },
          legend: { position: "bottom" },
        },
      },
    ],
    tooltip: {
      enabled: true,
      theme: "dark",
      style: {
        fontSize: '12px'
      },
      y: {
        formatter: function(value) {
          return value.toFixed(0); 
        }
      }
    },
  };

  return (
    <div style={{ width: "100%", maxWidth: "100%", height: "100%", minHeight: 300 }}>
      <ReactApexChart options={options} series={series} type="bar" height="100%" />
    </div>
  );
};

export default VerticalStackedBarChart;